import chalk from 'chalk'
import { EJavaBusinessResponseCode, EPHPBusinessResponseCode } from '~/enums/request'

export default defineNuxtPlugin(nuxtApp => {
  const runtimeConfig = useRuntimeConfig()
  const { javaHost } = runtimeConfig.public
  const { javaInnerHost } = runtimeConfig
  const isInApp = !!useCookie('C5AppVersion').value

  const baseURL = process.server ? javaInnerHost : javaHost
  console.log('baseURL', baseURL)

  const { get: getCustomHeaders } = useCustomHeaders()

  const api = $fetch.create({
    baseURL,
    onRequest({ request, options }) {
      if (process.server) {
        console.log(
          chalk.green.bold('[API Request]'),
          request,
          JSON.stringify(options, (_, value) => (typeof value === 'function' ? undefined : value))
        )
      }

      const customHeader = getCustomHeaders({
        url: request.toString(),
        method: options.method,
        deviceId: String(new Date().getTime()) + Math.ceil(Math.random() * 100000)
      })

      options.headers = {
        ...options.headers,
        ...customHeader
      }
    },
    async onResponse({ response }) {
      const data = response._data
      const errorCode = data?.errorCode

      if (process.server) {
        console.log(chalk.blue.bold('[API Response header]'), JSON.stringify(response.headers.entries(), null, 2))
        console.log(chalk.blue.bold('[API Response body]'), JSON.stringify(response._data, null, 2))
      }

      if (data?.errorCode !== 0 || response.status !== 200) {
        if (process.server) {
          console.log(chalk.red.bold('API Error'), 'Error Code:', errorCode, 'Data:', data)
        }
        switch (errorCode) {
          case EJavaBusinessResponseCode.NOT_LOGIN:
          case EPHPBusinessResponseCode.NOT_LOGIN:
            // 在app外时，跳转到登录页。app内时理论上一定是登录态，或者不需要登录。
            if (!isInApp) {
              await nuxtApp.runWithContext(() => {
                useCookie('H5_C5_AccessToken').value = ''
                const fullUrl = useCurrentDomain() + useRoute().fullPath
                navigateTo(`/login?returnUrl=${encodeURIComponent(fullUrl)}`, { replace: true })
              })
            }
            break
          case EJavaBusinessResponseCode.NOT_FOUND:
          case EJavaBusinessResponseCode.NOT_FOUND_4004:
            console.log('404')
            break
          case EJavaBusinessResponseCode.SERVER_ERROR:
          case EJavaBusinessResponseCode.SERVER_ERROR_999:
            console.log('服务器异常')
            break
          case EJavaBusinessResponseCode.MACHINE_VERIFICATION:
            console.log('需要人机校验')
            break
          case EJavaBusinessResponseCode.NOT_AUTHENTICATION:
            console.log('未认证')
            break
          case EJavaBusinessResponseCode.NOT_FULL_EIGHTEEN:
            console.log('未满十八岁')
            break
          default:
            console.log(data?.errorMsg || '')
        }

        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({
          ...data,
          errorMessage: data?.errorMsg || '',
          errorCode
        })
      } else {
        response._data = {
          ...response._data.data
        }
      }
    },
    onResponseError({ response }) {
      if (process.server) {
        console.log(chalk.red.bold('API Response Error'), response)
      }
    }
  })

  // Expose to useNuxtApp().$api
  return {
    provide: {
      api
    }
  }
})
